import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { NudgeNotification } from 'models/Notification';
import api from 'api';
import DislikeIcon from 'icons/Dislike.icon';
import LikeIcon from 'icons/Like.icon';
import ClockIcon from 'icons/Clock.icon';

import './BuyerNudgeNotification.styles.scss';

type BuyerNudgeNotificationProps = {
  className?: string;
  nudge: NudgeNotification;
  onWithdraw?: () => void;
  onConfirmInterest?: () => void;
  onSnooze?: () => void;
};

const BuyerNudgeNotification: React.FC<BuyerNudgeNotificationProps> = (
  props,
) => {
  const { className, nudge, onWithdraw, onConfirmInterest, onSnooze } = props;
  const { _id: id, leadId, dataRoomNodes } = nudge;

  const nudgeNode = dataRoomNodes?.[0];
  const tag = nudgeNode?.tag;
  const fileName = nudgeNode?.name;

  const { t } = useTranslation();
  const classes = classNames('buyer-nudge-notification', className);

  const handleWithdraw = useCallback(() => {
    api.portfolio.buyer.withdrawInterest(leadId);
    onWithdraw?.();
  }, [leadId, onWithdraw]);

  const handleConfirmInterest = useCallback(() => {
    api.nudges.confirmInterest(id);
    onConfirmInterest?.();
  }, [id, onConfirmInterest]);

  const handleSnooze = useCallback(() => {
    api.nudges.snoozeNudgeNotification(id);
    onSnooze?.();
  }, [id, onSnooze]);

  return (
    <div className={classes}>
      <div>
        <p className="buyer-nudge-notification__title">
          {t('youveSeenTheStillInterested', { tag: tag || fileName })}
        </p>
        <p className="buyer-nudge-notification__description">
          {t('confirmInterestToStayAprised')}
        </p>
      </div>
      <Button
        className="confirm-interest"
        icon={LikeIcon}
        onClick={handleConfirmInterest}
      >
        {t('stillInterested')}
      </Button>
      <Button
        variant="link"
        className="not-for-me"
        icon={DislikeIcon}
        onClick={handleWithdraw}
      >
        {t('notForMe')}
      </Button>
      <Button
        variant="link"
        className="snooze"
        icon={ClockIcon}
        onClick={handleSnooze}
      >
        {t('snoozeFor24hours')}
      </Button>
    </div>
  );
};

export default BuyerNudgeNotification;
